// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 61 ? "playing-cards" : chunkId) + "." + {"61":"bc87fefc960815734967","410":"219a19e98994b5fc96d8","411":"bd2d7613f17d5288a317"}[chunkId] + ".js";
};